module.exports = __webpack_public_path__ + "img/6.c31bd9d0.jpg";